import { createSlice } from '@reduxjs/toolkit';

export interface tireSensorState {
  data: any;
  isLoading: boolean;
}

const initialState: tireSensorState = {
  data: {},
  isLoading: false,
};

export const tireSensorSlice = createSlice({
  name: 'tireSensor',
  initialState,
  reducers: {
    setTireSensorData(state, { payload }) {
      state.data[payload.assetId] = payload.data;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
  },
});

export const { setIsLoading, setTireSensorData } = tireSensorSlice.actions;

export default tireSensorSlice.reducer;
